import type React from 'react';

import { fileExtensionToType, FileTypes } from '../lib/fileExtensionToType';
import { AudioVideoIcon } from './audio-video-icon';
import { DocIcon } from './doc-icon';
import { FolderIcon } from './folder-icon';
import { ImageIcon } from './image-icon';
import { OtherIcon } from './other-icon';
import { PdfIcon } from './pdf-icon';
import { PptIcon } from './ppt-icon';
import { XlsIcon } from './xls-icon';

const iconMap: {
  [key in FileTypes]: React.FC<React.SVGAttributes<SVGElement>>;
} = {
  [FileTypes.IMAGE]: ImageIcon,
  [FileTypes.VIDEO]: AudioVideoIcon,
  [FileTypes.AUDIO]: AudioVideoIcon,
  [FileTypes.PDF]: PdfIcon,
  [FileTypes.ARCHIVE]: FolderIcon,
  [FileTypes.WORD]: DocIcon,
  [FileTypes.EXCEL]: XlsIcon,
  [FileTypes.POWERPOINT]: PptIcon,
  [FileTypes.MISC]: OtherIcon,
};

export const getIcon = (extension: string) => {
  return iconMap[fileExtensionToType(extension)] ?? OtherIcon;
};
